import React from "react";
import StyledValue from "./StyledValue";

function format(percentage, noLeadingPlus) {
    const plusPrefix = !noLeadingPlus && (percentage > 0) ? "+" : "";
    return plusPrefix + percentage.toFixed(2);
}

export function numberToFormattedPercent(number) {
    if (!number) return "";

    const plusPrefix = (number > 0) ? "+" : "";
    const percent = fractionToPercent(number);
    return `${plusPrefix}${percent}%`;
}

export function fractionToPercent(number) {
    return (number === null) ? null : Number((number * 100).toFixed(2));
}

export default function PercentageChange(props) {
    if (props.change === null || props.change === undefined) {
        return <div className="t-percentage-change">&mdash;</div>
    }
    const value = (props.isFraction) ? fractionToPercent(props.change) : props.change;

    return <StyledValue value={value} className="t-percentage-change">{format(value, props.noLeadingPlus)}%</StyledValue>
}